export default function headerFix() {
  $(() => {
    if ($(window).scrollTop() > 50) {
      $(".l-header").addClass("fixed");
      $("body").addClass("is-fixed");
    } else {
      if ($(".l-header").hasClass("is-scroll-up")) {
        if ($(this).scrollTop() == 0) {
          $(".l-header").removeClass("fixed");
          $("body").removeClass("is-fixed");
        }
      } else {
        $(".l-header").removeClass("fixed");
        $("body").removeClass("is-fixed");
      }
    }

    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 50) {
        $(".l-header").addClass("fixed");
        $("body").addClass("is-fixed");
      } else {
        if ($(".l-header").hasClass("is-scroll-up")) {
          if ($(this).scrollTop() == 0) {
            $(".l-header").removeClass("fixed");
            $("body").removeClass("is-fixed");
            $(".l-header").removeClass("is-scroll-up");
            $("#content").removeClass("is-scroll-up");
          }
        } else {
          $(".l-header").removeClass("fixed");
          $("body").removeClass("is-fixed");
          $(".l-header").removeClass("is-scroll-up");
          $("#content").removeClass("is-scroll-up");
        }
      }
    });
  });
}
